import React, { useEffect, useState } from "react";
import { subscriptions } from "../../../state";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useTranslation } from "react-i18next";

interface SubscriptionProps {
  subscriptionData?: subscriptions | null;
}

const SubscriptionHistoryWidget = ({ subscriptionData }: SubscriptionProps) => {
  const [daysLeft, setDaysLeft] = useState<number | null>(null);
  const { t } = useTranslation("subscription");

  useEffect(() => {
    if (subscriptionData?.daysTotal !== undefined && subscriptionData?.daysUsed !== undefined) {
      setDaysLeft(subscriptionData.daysTotal - subscriptionData.daysUsed);
    }
  }, [subscriptionData]);

  if (!subscriptionData?.plan) {
    return (
      <div className="relative flex flex-col gap-[12px] w-full lg:w-[50%]">
        <p>{t("subscription.noActive")}</p>
        <div className="relative bg-[#ffffff] w-[80%] md:w-[70%] h-[7px]" />
      </div>
    );
  }

  return (
    <div className="relative flex flex-col gap-[12px] w-full lg:w-[50%]">
      {subscriptionData?.status === "pending" ? (
        <SkeletonTheme baseColor="#EDF2F5" highlightColor="#fff">
          <Skeleton width={"129px"} height={"12px"} />
        </SkeletonTheme>
      ) : (
        <p className="text-[16px] text-[#6B7280]">
          Plan expires in <span className="font-bold text-[#111827]">{daysLeft} days</span>
        </p>
      )}
      {/* {subscriptionData?.status === "pending" ? (
        <SkeletonTheme baseColor="#EDF2F5" highlightColor="#fff">
          <Skeleton width={"50%"} height={"8px"} />
        </SkeletonTheme>
      ) : (
        <div className="relative bg-[#ffffff] shadow-lg h-[7px] rounded-md w-[50%] md:w-[100%]">
          <div
            className="absolute bg-[#044E97] rounded-md h-full"
            style={{ width: `${((subscriptionData.daysUsed / subscriptionData.daysTotal) * 100).toFixed(2)}%` }}
          />
        </div>
      )} */}
    </div>
  );
};

export default SubscriptionHistoryWidget;
